import { api } from '@/lib/api';

/**
 * Upload a file to /media/upload and return the storage path.
 * Handles every known Laravel envelope shape so it can't silently fail.
 */
export async function uploadMedia(file: File): Promise<string> {
  const fd = new FormData();
  fd.append('file', file);

  const res: any = await api.post('/media/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  // Laravel: response { success, message, data: { id, url, path, name, ... } }
  // axios wraps as { data: <that>, status, headers, ... }
  const body = res?.data ?? res ?? {};
  const inner = body?.data ?? body;

  const candidates: any[] = [
    inner?.path,          // ← MediaController present() shape
    inner?.file_path,
    inner?.storage_path,
    inner?.url,
    body?.path,
    body?.file_path,
    body?.url,
    res?.path,
    res?.url,
  ];
  const found = candidates.find(v => typeof v === 'string' && v.trim().length > 0);

  if (!found) {
    const shape = JSON.stringify(body).slice(0, 400);
    throw new Error(`Upload returned 200 but no path was found. Response: ${shape}`);
  }
  return found;
}
